import { createStyles, HawkinsGlobalClass, makeStyles } from '@hawkins/styles';
export function appLogoStyles(theme) {
    var _a, _b;
    var hawkins = theme.hawkins, hawkinsVariables = theme.hawkinsVariables, hawkinsUtils = theme.hawkinsUtils;
    return createStyles({
        /** Class name of the app name container. */
        appName: {
            color: hawkins.textColor.textColorHeadingRegular,
            fontFamily: hawkins.brand.fontFamilyRegular,
            fontSize: hawkins.brand.fontSizeRegular,
            fontWeight: hawkins.heading.fontWeightRegular,
            lineHeight: hawkins.brand.lineHeightRegular,
            whiteSpace: 'nowrap',
        },
        /** Class name of the app name container when an environment label is present. */
        appNameWithEnvLabel: {
            fontFamily: hawkins.brand.fontFamilyAlpha,
            fontSize: hawkins.brand.fontSizeAlpha,
            lineHeight: hawkins.brand.lineHeightAlpha,
        },
        /** Class name of the environment label container. */
        envLabelContainer: {
            color: hawkins.textColor.textColorLight,
            fontFamily: hawkins.brand.fontFamilyAlphalabel,
            fontSize: hawkins.brand.fontSizeAlphalabel,
            fontWeight: hawkins.heading.fontWeightRegular,
            lineHeight: hawkins.brand.lineHeightAlphalabel,
            marginTop: hawkinsVariables.spacingValues.space0 / 2,
            textTransform: 'uppercase',
        },
        /** Class name of the icon container. */
        iconContainer: {
            alignItems: 'center',
            color: hawkins.icon.fillRegular,
            display: 'flex',
            fontSize: hawkinsVariables.fontSizes.fontSize4,
            fontWeight: hawkins.heading.fontWeightRegular,
            // 40px is the height of the Studio brand logo. Make the container for custom logos match this height.
            minHeight: 40,
            // Prevent inline SVGs from leaving a space underneath (see https://stackoverflow.com/a/21198616).
            '& svg': { verticalAlign: 'middle' },
        },
        /** Class name of the icon container when in a vertical navigation area and the Studio logo is being used. */
        iconContainerStudioVertical: {
            marginLeft: hawkinsVariables.spacingValues.space0 - 1,
        },
        /** Class name of the root element. */
        root: (_a = {
                alignItems: 'center',
                display: 'flex',
                gap: hawkinsVariables.spacingValues.space1 * 1.25,
                // In case `a` is the root element.
                textDecoration: 'none',
                // In case `button` is the root element.
                backgroundColor: 'transparent',
                borderWidth: 0,
                textAlign: 'start'
            },
            _a["&.".concat(HawkinsGlobalClass.FOCUSABLE)] = (_b = {},
                _b[hawkinsUtils.getFocusRingedElementSelector('&', '::after')] = hawkinsUtils.getFocusRingPosition(3),
                _b),
            _a),
        /** Class name of the root element when the component is a link or has a click handler. */
        rootClickable: {
            cursor: 'pointer',
        },
        /** Class name of the root element when the component is a link or has a click handler and is disabled. */
        rootClickableDisabled: {
            cursor: 'not-allowed',
        },
        /** Class name of the root element when in a transparent navigation component. */
        rootTransparent: {
            '& $appName': { color: hawkins.persistent.textColorWhiteRegular },
            '& $envLabelContainer': { color: hawkins.persistent.textColorWhiteLight },
            '& $iconContainer': { color: hawkins.persistent.iconFillWhiteRegular },
        },
        /** Class name of the element containing the app name and environment label. */
        textContainer: {},
    });
}
export var useAppLogoStyles = makeStyles(appLogoStyles, { name: 'Hawkins-AppLogo' });
